import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@mui/icons-material/Edit";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { Box, Grid } from "@mui/material";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { observer } from "mobx-react-lite";
import React, { useContext } from "react";
import Expand from "react-expand-animated";
import { Link, Redirect } from "react-router-dom";
import { BeatLoader } from "react-spinners";
import MemberCard from "../../components/MemberCard";
import SearchBar from "../../components/SearchBar";
import { RootStoreContext } from "../../store";
import style from "./Team_my.module.css";

import {
  acceptInvitation,
  allowJoin,
  eventList,
  inviteMember,
  leaveTeam,
  myTeam,
  rejectApplication,
  rejectInvitation,
  teamList,
  userList,
  allUserList,
} from "../../services/TeamService";

const { useState, useEffect, useCallback } = React;
const titleList = (members) => {
  const tl = [
    {
      title: "CEO",
      img: "",
      id: "",
    },
    {
      title: "CTO",
      img: "",
      id: "",
    },
    {
      title: "CFO",
      img: "",
      id: "",
    },
    {
      title: "CMO",
      img: "",
      id: "",
    },
    {
      title: "CDO",
      img: "",
      id: "",
    },
  ];
  for (let i = 0; i < tl.length; i++) {
    for (const key in members) {
      if (tl[i].title === members[key].title) {
        tl[i].img = members[key].img;
        tl[i].id = members[key].id;
      }
    }
  }
  return tl;
};

const memberData = {
  id: "12345678",
  first_name: "Shambhavi",
  last_name: "Mishra",
  avatar_url:
    "https://media.zenfs.com/zh-tw/petsmao_nownews_707/38fd0746221775e3ec2c94ba5fa6c0d6",
  des: "Shambhavi is a well-rounded web publisher with 15 years experience working.",
  ig_link: "https://www.instagram.com/ericchien21/",
  linkin_link: "https://www.instagram.com/ericchien21/",
  tiktok_link: "https://www.instagram.com/ericchien21/",
};

// const Events = [
//   { type: "apply", applicant: "麥克", position: "CTO" },
//   { type: "allow", name: "湯姆", applicant: "麥克" },
//   { type: "leave", name: "凱文" },
// ];

const PosIcon = ({ posName, img, userId }) => {
  return (
    <Stack spacing={1} alignItems="center" style={{ width: "100%" }}>
      <Link
        to={{ pathname: "/Profile_show", state: { id: userId } }}
        style={{ pointerEvents: !userId && "none" }}
      >
        <div className={style.social}>
          <img
            src={img}
            className={style.social}
            style={{ visibility: img === "" && "hidden" }}
            alt=""
          />
        </div>
      </Link>
      <p className={style.titleName}>{posName}</p>
    </Stack>
  );
};

const EventMsg = ({ event, status, update }) => {
  const [pressed, setPressed] = useState(false);
  const [canceled, setCancelled] = useState(false);
  useEffect(() => {
    update(status + 1);
  }, [pressed]);

  if (event.type === "apply") {
    return (
      <Stack spacing={1} style={{ display: canceled && "none" }}>
        <Typography variant="h8">
          {event.applicant}想要申請{event.position}職位。
        </Typography>
        <Stack direction="row" spacing={2} alignItems="center">
          <div className={style.applicantInfoBox}>
            <div className={style.applicantInfo}>
              <Stack direction="row" spacing={2} alignItems="center">
                <Link
                  to={{
                    pathname: "/Profile_show",
                    state: { id: event.applicantId },
                  }}
                >
                  <div className={style.social}>
                    <img
                      src={event.applicantImg}
                      className={style.social}
                      style={{
                        visibility: event.applicantImg === "" && "hidden",
                      }}
                      alt=""
                    />
                  </div>
                </Link>
                <p className={style.applicantName}>{event.applicant}</p>
              </Stack>
            </div>
          </div>
          <Stack alignItems="center" spacing={1} style={{ marginTop: "7px" }}>
            <button
              disabled={pressed}
              style={{
                background: pressed ? "#C1C1C1" : "#ffce26",
              }}
              className={style.allowBtn}
              onClick={() => {
                allowJoin(event.id).then(() => {
                  setPressed(true);
                });
                // handleAllow();
              }}
            >
              允許
            </button>
            <Button
              style={{ color: "#949494" }}
              onClick={() => {
                rejectApplication(event.id);
                setCancelled(true);
              }}
            >
              取消
            </Button>
          </Stack>
        </Stack>
      </Stack>
    );
  } else if (event.type === "allow") {
    return (
      <Typography variant="h8">
        {event.allower}允許{event.applicant}加入團隊。
      </Typography>
    );
  } else if (event.type === "allowed") {
    return (
      <Typography variant="h8">
        {event.applicant}成功加入，成為團隊中的{event.position}。
      </Typography>
    );
  } else if (event.type === "leave") {
    return <Typography variant="h8">抱歉{event.name}退出了團隊。</Typography>;
  } else if (event.type === "invite") {
    return (
      <Typography variant="h8">
        您所在的隊伍向{" "}
        <Link to={{ pathname: "/Profile_show", state: { id: event.talentId } }}>
          <b>{event.talent}</b>
        </Link>{" "}
        發出了組隊邀請。
      </Typography>
    );
  } else if (event.type === "rejected") {
    return (
      <>
        <Typography variant="h8">
          <Link
            to={{ pathname: "/Profile_show", state: { id: event.rejecterId } }}
          >
            <b>{event.rejecterName}</b>
          </Link>{" "}
          婉拒了您的邀請。
        </Typography>
      </>
    );
  } else if (event.type === "accepted") {
    return (
      <>
        <Typography variant="h8">
          恭喜🎉！{" "}
          <Link
            to={{ pathname: "/Profile_show", state: { id: event.talentId } }}
          >
            <b>{event.talentName}</b>
          </Link>{" "}
          加入了您的隊伍。
        </Typography>
      </>
    );
  }
  return <div />;
};

function ImageAvatars({ members }) {
  return (
    <div className={style.imgs}>
      <Stack direction="row" spacing={4}>
        {titleList(members).map((item, index) => (
          <PosIcon
            key={index.toString()}
            posName={item.title}
            img={item.img}
            userId={item.id}
          />
        ))}
      </Stack>
    </div>
  );
}

const TeamBox = ({ teamInfo, edit }) => {
  const [open, setOpen] = useState(false);
  const toggle = () => {
    setOpen(!open);
  };
  const transitions = ["height", "opacity", "background"];
  // console.log(teamInfo);
  return (
    <>
      <div className={style.TeamBox}>
        <ImageAvatars members={teamInfo.members} />
        <IconButton
          edge="start"
          onClick={toggle}
          className={style.expandBtn}
          style={{ transform: !open && "rotate(180deg)" }}
        >
          <KeyboardArrowDownIcon />
        </IconButton>
      </div>
      <Expand open={open} duration={1000} transitions={transitions}>
        <div className={style.introBox}>
          <Stack
            direction="row"
            alignItems="center"
            style={{ marginTop: "3%", marginLeft: "7%" }}
            spacing={49}
          >
            <div className={style.fieldBox}>
              <Box mr={1} ml={1} mt={0.4}>
                {teamInfo.field}
              </Box>
            </div>
            <Link
              to={"/team-3"}
              style={{ textDecoration: "none", visibility: !edit && "hidden" }}
            >
              <Button
                startIcon={<EditIcon sx={{ color: "#aaaaaa" }} />}
                sx={{ color: "#aaaaaa" }}
              >
                編輯
              </Button>
            </Link>
          </Stack>
          <p className={style.ideationTxt}>{teamInfo.ideation}</p>
        </div>
      </Expand>
    </>
  );
};

const wait = (ms) => {
  var start = new Date().getTime();
  var end = start;
  while (end < start + ms) {
    end = new Date().getTime();
  }
};

const Team_my = () => {
  const [mode, setMode] = useState("team");
  const handleMode = (option) => {
    setMode(option);
  };
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions();

    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);
  const updateDimensions = () => {
    const width = window.innerWidth;
    setWindowWidth(width);
    if (width > 1339) setMode("team");
  };
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => setLoading(false), 3000);
  }, []);
  // const [, updateState] = useState();
  // const [refetch, setRefetch] = useState(false);
  const [refresh, setRefresh] = useState(0);
  const [redirect, setRedirect] = useState(false);
  const { TeamStore } = useContext(RootStoreContext);
  const { teamId, teamname, field, ideation, members, updateData } = TeamStore;

  const [myteam, setMyteam] = useState(members);
  const [teams, setTeams] = useState([]);
  const [positions, setPositions] = useState([]);

  useEffect(() => {
    myTeam().then((value) => {
      if (value) {
        console.log("loading");
        updateData("members", value.members);
        setMyteam(value.members);
        const tmp = [];
        for (const member of value.members) tmp.push(member.title);
        setPositions(tmp);
      }
    });
    teamList().then((value) => {
      setTeams(value);
    });
  }, [updateData]);

  const [events, setEvents] = useState([]);
  useEffect(() => {
    eventList(teamId).then((value) => {
      setEvents(value.reverse().slice(0, 5));
    });
    myTeam().then((value) => {
      if (value) {
        updateData("members", value.members);
        setMyteam(value.members);
      }
    });
  }, [redirect]);

  const [users, setUsers] = useState([]);
  const [filteredUser, setFilteredUser] = useState([]);
  const [searchText, setSearchText] = useState("");

  useEffect(() => {
    allUserList().then((value) => {
      let users = [];
      value.forEach(user => {
        let tmpUser = user;
        let completion = 0
        if(!user.softPower) tmpUser.softPower = ""
        else completion++
        if (!user.hardPower) tmpUser.hardPower = ""
        else completion++
        if(!user.motivation) tmpUser.motivation = ""
        else completion++
        if(!user.experience) tmpUser.experience = ""
        else completion++
        tmpUser.completion = completion
        users.push(tmpUser)
      })
      let usersSorted = users.sort((a, b) => {
        if (a.completion > b.completion) {
          return -1;
        }
      });
      setUsers(usersSorted);
      const tmp = [];
      for (let i = 0; i < Number(usersSorted.length / 3); i += 3) {
        tmp.push(
          i === usersSorted.length - (usersSorted.length % 3)
            ? usersSorted.slice(i, usersSorted.length)
            : usersSorted.slice(i, i + 3)
        );
      }
      setFilteredUser(tmp);
    });
  }, []);

  const filterUser = (text) => {
    let text_lower = text.toLowerCase()
    let value = users.filter(user => 
      user.name.toLowerCase().includes(text_lower) ||
      user.softPower.toLowerCase().includes(text_lower) ||
      user.hardPower.toLowerCase().includes(text_lower) || 
      user.motivation.toLowerCase().includes(text_lower) ||
      user.experience.toLowerCase().includes(text_lower)
    )
    const tmp = [];
    for (let i = 0; i < Number(value.length / 3); i += 3) {
      tmp.push(
        i === value.length - (value.length % 3)
          ? value.slice(i, value.length)
          : value.slice(i, i + 3)
      );
    }
    setFilteredUser(tmp);
  }

  const handleChangeSearchText = (text) => {
    setSearchText(text);
    filterUser(text);
  }

  const handleInviteMember = (memberId, pos) => {
    let request = {
      uid: memberId,
      position: pos,
      teamName: teamname,
      teamId: teamId,
      teamField: field,
      teamDescription: ideation,
    };
    inviteMember(request);
  };

  // const [leaveteam, setLeaveteam] = useState(false);
  // const handleLeave = () => {
  //   setLeaveteam(true);
  // };
  // useEffect(() => {
  //   if (leaveTeam) {
  //     leaveTeam().then(() => {
  //       getTeamId(user.id);
  //       checkCEO(user.id);
  //     });
  //   }
  // }, [leaveteam]);
  if (loading) return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0, 0, 0, 0.5)' }}>
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)' }}>
        <BeatLoader loading={loading} />
        <p>Loading...</p>
      </div>
    </div>
  );

  return (
    <Grid
      container
      className={style.main}
      direction="row"
      justifyContent="center"
      alignItems="flex-start"
      style={{ width: "fit-content !important" }}
    >
      <Grid item md={6}>
        <div style={{}}>
          <Box
            sx={{
              display: "flex",
              width: "39em",
              justifyContent: "space-between",
              marginBottom: width < 1339 && "15px",
            }}
          >
            <Typography
              variant="h5"
              style={{ fontWeight: 700, color: "#575757" }}
            >
              我的隊伍
            </Typography>
            <Link
              to={{
                pathname: "/main",
                state: { justLeft: true },
              }}
            >
              <button className={style.leaveBtn} onClick={leaveTeam}>
                離開隊伍
              </button>
            </Link>
          </Box>
        </div>
        <Box mb={1} ml={2}>
          <Typography
            variant="h6"
            style={{ color: "#575757", fontWeight: "700" }}
          >
            {teamname}
          </Typography>
        </Box>
        <TeamBox
          teamInfo={{ field: field, ideation: ideation, members: myteam }}
          edit={true}
        />
        <div className={style.split} />
        <Stack
          direction="row"
          justifyContent="flex-start"
          spacing={5}
          sx={{
            marginBottom: "3%",
            width: "90%",
          }}
        >
          <Button
            disabled={mode === "team"}
            onClick={() => {
              handleMode("team");
            }}
            sx={{
              borderBottom: mode === "team" && "solid 4px #FFCE26",
              borderRadius: "0px !important",
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontWeight: 700,
                color: mode !== "team" ? "#BFBDBD" : "#575757",
                whiteSpace: "nowrap",
              }}
            >
              其他隊伍
            </Typography>
          </Button>
          <Button
            disabled={mode === "member"}
            onClick={() => {
              handleMode("member");
            }}
            sx={{
              borderBottom: mode === "member" && "solid 4px #FFCE26",
              borderRadius: "0px !important",
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontWeight: 700,
                color: mode !== "member" ? "#BFBDBD" : "#575757",
                whiteSpace: "nowrap",
              }}
            >
              使用者列表
            </Typography>
          </Button>
          <Button
            disabled={mode === "event"}
            onClick={() => {
              handleMode("event");
            }}
            style={{
              visibility: width > 1339 && "hidden",
              borderBottom: mode === "event" && "solid 4px #FFCE26",
              borderRadius: "0px !important",
            }}
          >
            <Typography
              variant="h5"
              style={{
                fontWeight: 700,
                color: mode === "event" ? "#575757" : "#BFBDBD",
              }}
            >
              事件
            </Typography>
          </Button>
        </Stack>
        <Stack
          spacing={4}
          style={{
            marginTop: "2.5%",
            display: mode !== "team" && "none",
          }}
        >
          {teams.map((item, index) => {
            if (item.id !== teamId)
              return (
                <div>
                  <Box mb={1} ml={2}>
                    <Typography
                      variant="h6"
                      style={{ color: "#575757", fontWeight: "700" }}
                    >
                      {item.teamname ? item.teamname : <br />}
                    </Typography>
                  </Box>
                  <TeamBox key={index.toString()} teamInfo={item} />
                </div>
              );
            else return <div></div>;
          })}
        </Stack>
        <div
          style={{
            display: mode !== "member" && "none",
          }}
        >
        <SearchBar handleChangeSearchText={handleChangeSearchText}/>
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="flex-start"
            spacing={6}
          >
            {filteredUser.map((mg) => {
              return (
                <Stack
                  direction="row"
                  justifyContent="center"
                  alignItems="center"
                  spacing={6}
                >
                  {mg.map((user) => {
                    return (
                      <MemberCard
                        memberData={user}
                        positions={positions}
                        onInvite={(pos) => {
                          handleInviteMember(user.id, pos);
                        }}
                        refresh={() => {
                          setRedirect(!redirect);
                        }}
                      />
                    );
                  })}
                </Stack>
              );
            })}
          </Stack>
        </div>
        <div></div>
        <div
          style={{
            marginTop: "10%",
            visibility: mode !== "event" && "hidden",
          }}
        >
          <Stack spacing={2}>
            {events.length > 0
              ? events.map((item) => (
                <EventMsg event={item} update={setRefresh} status={refresh} />
              ))
              : "沒有任何事件"}
          </Stack>
        </div>
      </Grid>
      <Grid item md={6} style={{ visibility: width < 1339 && "hidden" }}>
        <Typography
          color="#575757"
          variant="h5"
          style={{ fontWeight: 700, visibility: width < 1339 && "hidden" }}
        >
          事件
        </Typography>
        <div style={{ marginTop: "5%" }}>
          <Stack spacing={2}>
            {events.length > 0
              ? events.map((item) => (
                <EventMsg event={item} update={setRefresh} status={refresh} />
              ))
              : "沒有任何事件"}
          </Stack>
        </div>
      </Grid>
    </Grid>
  );
};

export default observer(Team_my);
